import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';
import './styles.scss';
import 'antComponentsStyle';

const inputSlider = React.forwardRef((props, ref) => {
  const {
    range,
    step,
    additionalSteps,
    onChange,
    onAfterChange,
    labelFormatter,
    withStepLabel,
    tooltipVisible,
    disabled
  } = props;

  let { min, max, steps, value } = props;

  const onChangeHandler = values => {
    if (typeof onChange === 'function') {
      onChange(values);
    }
  };

  const onAfterChangeHandler = values => {
    if (typeof onAfterChange === 'function') {
      onAfterChange(values);
    }
  };

  if (range) {
    if (step) {
      steps = {}

      for (let idx = min; idx <= max; idx += step) {
        if (value.indexOf(idx) >= 0) {
          steps[idx] = {
            label: labelFormatter(idx),
            style: withStepLabel
              ? {
                  fontWeight: '600',
                  color: 'red'
                }
              : { display: 'none' },
          };
        } else {
          steps[idx] = {
            label: labelFormatter(idx),
            style: withStepLabel
              ? {
                  fontSize: '.7em',
                  color: 'red'
                }
              : { display: 'none' },
          };
        }
      }

      if (additionalSteps && additionalSteps.length) {
        additionalSteps.forEach(step => {
          if (value.indexOf(step) >= 0) {
            steps[step] = {
              label: labelFormatter(step),
              style: withStepLabel
                ? {
                    fontWeight: '600',
                    color: 'green'
                  }
                : { display: 'none' },
            };
          } else {
            steps[step] = {
              label: labelFormatter(step),
              style: withStepLabel
                ? {
                    fontSize: '.7em',
                    color: 'green'
                  }
                : { display: 'none' },
            };
          }
        });
      }
    } else {
      for (let idx in steps) {
        const style = steps[idx].style ? steps[idx].style :
          withStepLabel ? {
            fontWeight: '600',
            color: 'red'
          }
        : { display: 'none' };

        steps[idx] = {
          label: labelFormatter(idx),
          style,
        }
      }
    }
  } else if (steps && (!min || !max)) {
    min = parseFloat(Object.keys(steps).sort((val1, val2) => parseFloat(val1) - parseFloat(val2))[0]);
    max = parseFloat(Object.keys(steps).sort((val1, val2) => parseFloat(val1) - parseFloat(val2)).slice(-1)[0]);

    for (let idx in steps) {
      const style = steps[idx].style ? steps[idx].style :
        withStepLabel ? {
          fontWeight: '600',
          color: 'red'
        }
      : { display: 'none' };

      steps[idx] = {
        label: labelFormatter(idx),
        style,
      }
    }
  }

  if (!value && value !== 0) {
    value = max
  }

  return (
    <div className="InputSlider">
      <Slider
        range={range}
        included={true}
        marks={steps}
        value={value}
        disabled={disabled || min === max || (steps && Object.keys(steps).length < 2)}
        min={min}
        max={max}
        onChange={onChangeHandler}
        onAfterChange={onAfterChangeHandler}
        step={step}
        tooltipVisible={tooltipVisible}
        getTooltipPopupContainer={node => node} /*https://github.com/ant-design/ant-design/issues/37004*/
        tipFormatter={value => labelFormatter(value)}
        ref={ref}
        aria-hidden="true"
        className="user-select-none"
      />
    </div>
  );
});

inputSlider.defaultProps = {
  withStepLabel: true,
  range: true,
  tooltipVisible: false,
  disabled: false
};

inputSlider.propTypes = {
  steps: PropTypes.object,
  range: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onAfterChange: PropTypes.func,
  step: PropTypes.number,
  additionalSteps: PropTypes.array,
  labelFormatter: PropTypes.func.isRequired,
  withStepLabel: PropTypes.bool,
  tooltipVisible: PropTypes.bool,
  disabled: PropTypes.bool
};

export default inputSlider;
